export default {"src":"/_next/static/media/logo-nova.72fe1368.svg","height":40,"width":89,"blurWidth":0,"blurHeight":0};